/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable react/button-has-type */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-key */
import React, { useState } from 'react';
import { Grid, Box, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import moment from 'moment';
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { ClockIcon, DocumentTextIcon, AcademicCapIcon, GlobeAltIcon, CheckCircleIcon, CheckBadgeIcon, UsersIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import helper from '../../../utils/helper';
import Page from '../../../components/Page';
import trialAndStripeSubscriptionService from '../../../services/trialAndStripeSubscriptionService';
import { openSnackbar} from '../../../store/reducer';
import Footer from '../../../components/Footer'


const getStatusLabel = (course) => {
  // if (course.is_free) return { text: "Free", color: "bg-green-100 text-green-700" };
  // if (!course.is_free && course.isTrial)
  //   return { text: "Trial", color: "bg-yellow-100 text-yellow-700" };
  // return { text: "Not Started", color: "bg-gray-200 text-gray-700" };
  return { 
    text: "In Progress", 
    color: "bg-[#FFF6E6] text-[#FFA500]" 
  };
};
const BundleDetails = () => {
  const location = useLocation()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userSubscribedCourses } = useSelector((state) => state);
  const [isSubscribed, setIsSubscribed] = useState(true);
  const [viewPrice, setViewPrice] = useState(0);
  const [loadinButton, setLoadinButton] = useState(false);
  const [isPaid, setisPaid] = useState(false);
  const [coursetabIndex, setcourseTabIndex] = useState(0);

  
  
  const [openIndex, setOpenIndex] = useState(null);

  const OverViewTabs = [
    <Tab id="Overview-section" key="Overview" label="Overview" />,
    <Tab id="Learning Path" key="Learning Path" label="Learning Path" />,
    <Tab id="Achivements-section" key="Achivements" label="Achivements" />,
  ];

  const userid = useSelector((state) => state.userInfo && state.userInfo.id);


  

  // eslint-disable-next-line no-unused-vars
  const [intfrequency, setintfrequency] = React.useState(1);
  const allcourseDetails = useSelector((state) => state);

  const userRole = useSelector((state) => state.userInfo && state.userInfo.role);
  React.useMemo(() => {
    const filteredList = location?.state?.item?.prices.filter(data =>
      allcourseDetails?.currency === 'USD'
        ? data?.currencyType?.id === 2
        : data?.currencyType?.id === 1
    );


    let displayPrice;

    if (filteredList && filteredList?.length > 0 && allcourseDetails?.currency === 'USD') {
      displayPrice = `$${filteredList[0]?.actualCost}`;
    } else if (filteredList && filteredList?.length > 0 && allcourseDetails?.currency === 'INR') {
      displayPrice = `₹${filteredList[0]?.actualCost}`;
    } else if (filteredList && filteredList?.length === 0) {
      displayPrice = 'NAN'
    }
    setViewPrice(displayPrice)

  }, [allcourseDetails])



  React.useEffect(() => {
    if (userSubscribedCourses.length > 0) {
      setIsSubscribed(true);
      setisPaid(false);

      const obj = userSubscribedCourses.find((item) => item?.subscriptionPlanId === location.state?.item?.subscriptionPlanId);
      if (obj !== undefined) {
        if (obj.isTrial === false && obj.isSubscribed === false) {
          setisPaid(false);

          setIsSubscribed(true);
        } else {
          setisPaid(true);

          setIsSubscribed(!obj.isSubscribed);
        }
      }
    }
  }, [location.state?.item]);

  const postSubscribeDetails = async (item, planId) => {
    setLoadinButton(true)
    const courseId = item.id;
    if (item?.isPaid) {
      // dispatch(setOpenSubscriptionModalDetails(item));
      // dispatch(openSubscriptionModal(planId));
      let impactClickId = '';
      try {
        impactClickId = await helper.getClickId();
      } catch (error) {
        console.error(error);
        impactClickId = '';
      }

      const payload = {
        userId: userid,
        planId,
        currencyType: allcourseDetails?.currency,
        frequency: parseInt(intfrequency, 10),
        impactClickId,
      };

      console.log(payload, "payloadpayload");


      try {
        const res = await trialAndStripeSubscriptionService.createStripeSubscription(JSON.stringify(payload));
        if (res.status === 303) {
          // dispatch(closeSubscriptionModal());
          // setSubscriptionModalLoading(false);
          setLoadinButton(false)
          window.location = res.data.paymentUrl;
        } else if (res?.data?.message) {
          setLoadinButton(false)
          dispatch(openSnackbar(res.data.message));
        } else {
          setLoadinButton(false)
          dispatch(openSnackbar('Failed to Subscribe, Please try again.'));
        }
        // setSubscriptionModalLoading(false);

      } catch (error) {
        setLoadinButton(false)

        console.log(error);
      }
    } else {
      //   setIsSubscribing(planId);
      setLoadinButton(true)

      try {
        const res = await trialAndStripeSubscriptionService.createStripeSubscription(JSON.stringify({ planId }));
        if (res.ok) {
          setLoadinButton(false)

          navigate('/auth/subscribe');
          //   setCardView("MyLearning")
          //   setOpenNewCourses(false)
          // setCardViewSubMenu("MyLearning")
          dispatch(openSnackbar('Course subscribed successfully'));
        } else if (res.status === 400) {
          setLoadinButton(false)

          dispatch(openSnackbar(res.data.message));
        } else {
          setLoadinButton(false)

          dispatch(openSnackbar('Failed to subscribe, please try again'));
        }
      } catch (error) {
        setLoadinButton(false)

        console.log(error);
      }
      //   setIsSubscribing(null);
    }
  };

  const { t } = useTranslation('translation');

  const handleCardClickItem = (data) => {
    if (userRole === 'USER_DTC') {
      // navigate('/auth/course-details', { state: data });
      navigate(`/auth/course-details/${data.id}/${data.subscriptionPlanId || data.subscriptionplanid || data?.planId || ""}`, {
        state: {
          ...data,
          // subscriptionPlanId: 129,
          subscriptionPlanId: data?.planId,
          comingfrom: 'bundle',
          detail:location.state.item,
          subscription_name:location.state.item?.additionalSubscriptionDetails?.name

        }
      });
    } else {
      // navigate('/app/course-details', { state: data });
      navigate(`/auth/course-details/${data.id}/${data.subscriptionPlanId || data.subscriptionplanid || data?.planId || ""}`, {
        state: {
          ...data,
          subscriptionPlanId: data?.planId,
          comingfrom: 'bundle',
          detail:location.state.item,
          subscription_name:location.state.item?.additionalSubscriptionDetails?.name
        }
      });
    }
  };
  const uniqueCourseObjs = location.state.item?.courseObj?.filter((value, index, self) =>
    index === self.findIndex((obj) => obj.id === value.id)
  )

  


  const validFrom = allcourseDetails.AllCourseDetails
  ?.find(data => data.id === uniqueCourseObjs[0]?.id)
  ?.validFrom;
  
  const stats = [
    { label: "Flexible Time", title: "Flexible Time", icon: ClockIcon },
    { label: "Courses", title: uniqueCourseObjs && uniqueCourseObjs?.length, icon: DocumentTextIcon },
    { label: "Course Type", title: "Bundle", icon: AcademicCapIcon },
    { label: "Language Used", title: "English", icon: GlobeAltIcon },
  ];


  const handleGoBack = () => {
    navigate('/auth/subscribe');
  }
  const handleCourseTabChange = (newValue) => {
    setcourseTabIndex(newValue);
  };



  return (
    <>
      <Page title={'Bundle-details'}>

        <Grid item xs={12} sm={12}>
          <div className="relative w-full h-[350px] rounded-lg overflow-hidden">
            <img src={location.state?.item?.image_url} alt="Course Cover" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent" />
            <div className="absolute top-6 left-14 text-white space-y-3 max-w-[60%]">
              <button onClick={handleGoBack} className="text-sm flex items-center gap-2 hover:underline">
                ← Back
              </button>
              <h1 className="text-3xl font-bold leading-snug">
                {location.state?.item?.subscriptionPlanName}
              </h1>
              {location.state?.item?.description && (
                <p className="text-sm md:text-base opacity-90">
                  {location.state?.item?.description}
                </p>
              )}

              <div className="flex items-center gap-6 text-sm">
                <div className="flex items-center gap-1">
                  ⭐ <span>4.8</span>
                </div>
                <div className="flex items-center gap-1">
                  <UsersIcon className="w-5 h-5 text-[#fff]" /><span>500</span>
                </div>
              </div>

            </div>
          </div>



          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: "35px", marginLeft: '20px' }}>
            {/* <IconButton size="small" onClick={handleGoBack}>
              <ArrowBackIcon color="inherit" />
            </IconButton>
            <Typography variant="h5" sx={{ textAlign: 'left', marginLeft: '0px',  marginBottom: '0px', flexGrow: 1 }}>
              {t("Include Courses")}
            </Typography> */}





            {/* <div className="flex overflow-x-auto scrollbar-hide gap-2 
                w-full sm:w-[90%] md:w-[60%] lg:w-[40%] 
                mx-auto sm:ml-4 md:ml-8">

              {OverViewTabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={(e) => handleCourseTabChange(e, index)}
                  className={`px-4 py-1.5 text-sm rounded-lg transition-all duration-200 whitespace-nowrap
                  ${coursetabIndex === index
                      ? "bg-white text-black shadow-sm font-medium"
                      : "text-gray-500 hover:text-black"}`}
                >
                  {tab}
                </button>
              ))}
            </div> */}
          </Box>

          <div className="mt-4 mb-4 px-6 sm:px-8 md:px-10 lg:px-12">
            <div className="flex flex-col md:flex-row md:justify-between">

              <div className="flex flex-wrap gap-2 bg-gray-100 rounded-xl p-2">
                {OverViewTabs.map((tab, index) => (
                  <button
                    key={index}
                    onClick={(e) => handleCourseTabChange(index)}
                    className={`px-3 py-1.5 text-xs sm:text-sm md:text-base rounded-lg transition-all duration-200
            ${coursetabIndex === index
                        ? "bg-white text-black shadow-sm font-medium"
                        : "text-gray-500 hover:text-black"
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>

            </div>
          </div>

          {coursetabIndex === 0 && (
            <>
              <div className="w-[93%] mx-auto">
                <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-[repeat(auto-fit,minmax(240px,1fr))] justify-center">
                  {stats?.map((item, index) => {
                    const Icon = item.icon;

                    return (

                      <div key={index}
                        className="bg-[rgba(255,255,255,0.15)] backdrop-blur-md rounded-2xl p-6 
                        flex flex-col items-start text-left shadow-md 
                        hover:bg-[rgba(255,255,255,0.25)] transition-all duration-500"
                      >
                        <Icon className="w-6 h-6 mb-3 text-black" />
                        <span className="text-4.5xl font-bold">{item.value}</span>
                        <span className="text-4xl font-bold">{item?.title}</span>
                        <p className="mt-2 text-sm opacity-90">{item.label}</p>
                      </div>

                    );
                  })}
                </div>
              </div>


              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-[93%] mx-auto">
                <div className="md:col-span-2 border rounded-xl p-6 bg-white shadow-sm">
                  <h2 className="text-lg font-semibold mb-2">About This Course</h2>

                  {/* Description */}
                  {location.state?.item?.description && (
                    <p className="text-sm text-gray-600 mb-4">
                      {location.state?.item?.description}
                    </p>
                  )}

                  {/* Short Description */}
                  <h3 className="text-sm font-medium mb-3">What you'll learn</h3>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3">
                    {location.state?.item?.short_desc?.length > 0 ? (
                      location.state?.item?.short_desc?.map((item, i) => (

                        <div key={i} className="flex items-center gap-2 text-sm text-gray-700">
                          <CheckCircleIcon className="w-5 h-5 text-[#32D74B]" />
                          <span>{item}</span>
                        </div>

                      ))
                    ) : (
                      <p className="text-gray-400 text-sm">No details available</p>
                    )}
                  </div>
                </div>

                <div className="border rounded-xl p-6 bg-white shadow-sm flex flex-col justify-between">
                  {isPaid ? <p className="text-lg text-green-600 font-semibold mb-4">• Purchased</p> :
                    <h3 className="text-lg font-semibold mb-4">{viewPrice}</h3>}
                  {isPaid ? <button onClick={() => handleCourseTabChange(1)} className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-sm mb-5">
                    Continue Learning
                  </button>
                    :
                    <button onClick={() => { postSubscribeDetails(location?.state?.item, location?.state?.item?.subscriptionPlanId) }} className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-sm mb-5">
                      Enroll Now
                    </button>}

                  <div className="space-y-3 text-sm text-gray-700">
                    <div className="flex justify-between"><span>SkillsetIQ</span><span className="font-medium">Included</span></div>
                    {isPaid && <div className="flex justify-between"><span>Enrolled on</span><span className="font-medium">{ moment(validFrom).format("LL")}</span></div>}
                    <div className="flex justify-between"><span>Certificate</span><span className="font-medium">Included</span></div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* <Box className="pannelParent" style={{ boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', borderRadius: '16px', padding: '35px 0px 15px', margin: '0px 30px' }}>
            {location && uniqueCourseObjs.map((data) => (
              <Grid style={{ height: '100%', marginBottom: '20px' }}>
                <Box sx={{ textAlign: 'center' }}>
                  <StyledCard sx={{ height: '300px' }}>
                    <Box sx={{ position: 'relative', width: { xs: '55%', sm: '45%', md: '30%' }, height: '100%', minWidth: { xs: '100px', sm: '120px', md: '290px' } }}>
                      <CardMedia
                        component="img"
                        height="100%"
                        width="100%"
                        image={data?.thumbImage}
                        alt="Course Image"
                        sx={{ objectFit: 'inherit', cursor: 'pointer' }}
                        onClick={() => handleCardClickItem(data)}
                      />
                    </Box>
                    <CardContent
                      sx={{
                        width: '60%',
                        height: '95%', overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        gap: 2,
                      }}
                    >
                      <Box sx={{ textAlign: 'left' }}>
                        <Typography variant="h6" component="div" marginBottom={3}>
                          {data?.title}
                        </Typography>
                        <Typography
                          variant="body2" component="p"
                          sx={{
                            flexGrow: 1,
                            fontSize: '0.8rem',
                          }}
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data?.description) }}
                        />
                      </Box>

                    </CardContent>
                  </StyledCard>
                </Box>
              </Grid>

            ))}
          </Box> */}
          {coursetabIndex === 1 &&
            <div className="p-6 bg-gray-50 rounded-xl w-[93%] mx-auto border border-gray-300 shadow-md space-y-4">
              <h2 className="text-xl font-semibold mb-4">Learning Path</h2>
              {uniqueCourseObjs && uniqueCourseObjs?.length > 0 && uniqueCourseObjs.map((course, index) => {
                const status = getStatusLabel(course);
                return (
                  <div key={course.id} className="mb-3 mt-4 border border-gray-200 rounded-lg shadow-sm bg-white min-h-19" >
                    <button className="w-full flex justify-between items-center p-4 cursor-pointer" >
                      <div className="flex items-center space-x-3">
                        <div className="w-7 h-7 bg-gray-200 rounded-full flex items-center justify-center font-semibold">
                          {index + 1}
                        </div>
                        {/* onClick={() => handleCardClickItem(course)} */}
                        <div>
                          {/* <span onClick={() => handleCardClickItem(course)} style={{ fontSize: "14px", marginLeft: "12px", cursor: "pointer", color: 'black', textDecoration: 'underline' }}>{course.title}</span> */}
                          <button
                            onClick={() => handleCardClickItem(course)}
                            className="text-black underline cursor-pointer ml-3 text-sm"
                          >
                            {course.title}
                          </button>
                        </div>
                      </div>
                      {/* <span className={`ml-auto px-3 py-1 text-xs font-semibold rounded-full ${status.color}`}>
                        {status.text}
                      </span> */}
                      <ChevronDownIcon onClick={() => setOpenIndex(openIndex === index ? null : index)} className={`w-5 h-5 ml-2 transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""}`} />
                    </button>

                    {openIndex === index && (
                      <div className="px-6 pb-4 ml-9">
                        <h4 className="font-semibold text-sm mb-2">What you'll learn</h4>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3">
                          {course?.shortDescription?.length > 0 ? (
                            course?.shortDescription?.map((item, i) => (
                              <div key={i} className="flex items-center gap-2 text-sm text-gray-700">
                                <CheckCircleIcon className="w-5 h-5 text-[#32D74B]" />
                                <span>{item}</span>
                              </div>

                            ))
                          ) : (
                            <p className="text-gray-400 text-sm">No details available</p>
                          )}
                        </div>
                        {/* {Array.isArray(course.short_desc) && course.short_desc.length > 0 ? (
                      course.short_desc.map((item, i) => (
                        <div key={i} className="flex items-center gap-2 text-sm text-gray-700">
                        <CheckCircleIcon className="w-5 h-5 text-[#32D74B]" />
                        <span>{item}</span>
                      </div>
                      ))
                    ) : (
                      <p className="text-gray-500 text-sm">No details available</p>
                    )} */}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

          }

          {coursetabIndex === 2 &&
            <div className="w-full flex justify-center px-4">
              <div className="w-full md:w-[60%] lg:w-[50%] bg-white border border-gray-200 rounded-xl shadow-sm p-6 text-center">

                <div className="flex justify-center mb-3">
                  <div className="w-14 h-14 flex items-center justify-center bg-gray-100 rounded-full">
                    <CheckBadgeIcon className="w-9 h-9 text-gray-500" />
                  </div>
                </div>

                <h2 className="text-lg md:text-xl font-semibold text-gray-900">
                  Achievements & Certificates are available in the Individual Courses
                </h2>

                <p className="text-gray-500 text-sm md:text-base mt-2">
                  You can explore all your badges, progress milestones, and certificate details inside
                  individual course modules.
                </p>

                <div className="mt-4 text-gray-600 text-sm md:text-base leading-relaxed">
                  <p>Here are the steps to access:</p>
                  <p className="mt-1">(1) Go to Individual Courses from Learning Path</p>
                  <p>(2) Open the Achievements tab</p>
                  <p>(3) Download the certifications you have earned</p>
                </div>

                <p className="mt-5 font-medium text-gray-700">🎉 Happy Learning!</p>
              </div>
            </div>
          }

        </Grid>
        <Footer />
      </Page>
    </>
  )
}
export default BundleDetails;